// @flow
import interval from "./useInterval";

export const useInterval = interval;
